import { EventTypes } from '@racemap/sdk/schema/events';

export const getEventTypeLabel = (eventType: EventTypes | undefined, index?: number): string => {
  switch (eventType) {
    case EventTypes.REGULAR:
      return '';
    case EventTypes.SAFEMAP:
      return 'Safemap';
    case EventTypes.CONTEST_GROUP:
      return 'Contest Group';
    case EventTypes.STAGE_GROUP:
      return 'Stage Group';
    case EventTypes.CONTEST:
      return index != null ? `Contest ${index + 1}` : 'Contest';
    case EventTypes.STAGE:
      return index != null ? `Stage ${index + 1}` : 'Stage';
    default:
      return 'Unknown';
  }
};
